<template>
  <div class="send">
    <el-input
      type="textarea"
      v-model="inputMessage"
      :rows="2"
      placeholder="请输入你要写的内容..."
      resize="none"
      class="chat-input"
      @keyup.enter.native="sendUserMessage"
    ></el-input>
    <div class="tags-list">
      <el-checkbox
        v-model="questionParams.deep_seek"
        label="深度思考"
        border
        class="no-inner"
      >
        <div class="switch">
          <img src="../assets/deep.png" alt="" width="14px" />&nbsp; 深度思考
        </div>
      </el-checkbox>
      <el-checkbox
        v-model="questionParams.enable_search"
        label="联网搜索"
        border
        class="no-inner"
      >
        <div class="switch">
          <img src="../assets/online-search.png" alt="" width="14px" />&nbsp; 联网搜索
        </div>
      </el-checkbox>
      <el-radio-group v-model="selectedTags" class="tags">
        <el-radio
          border
          class="radio"
          v-for="item in tagList"
          :key="item.id"
          :label="item.knowledgeCode"
        >
          {{ item.knowledgeName }}
        </el-radio>
      </el-radio-group>
    </div>
    <img
      src="../assets/send.png"
      alt=""
      :class="['send-btn', loading && 'disabled']"
      @click="sendUserMessage"
    />
  </div>
</template>

<script>
import { knowledgeLibrary, getModelConfig } from '@/api';

export default {
  name: "MessageInput",
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputMessage: "",
      selectedTags: "",
      tagList: [],
      questionParams: {
        modelKey: 'doubao',
        max_token: 5120,
        temperature: 0.7,
        deep_seek: true,
        enable_search: true,
        stream: true,
        history: [],
        question: '',
        topic_ids: ['gJVQXlD0'],
        refs: false,
      },
    };
  },
  mounted() {
    if (this.isLogin) {
      this.getLibrary();
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.getLibrary();
      }
    },
  },
  methods: {
    getDefaultModelConfig() {
      getModelConfig().then((response) => {
        const modelConfig = response.data;
        this.questionParams.modelKey = modelConfig.modelKey || this.questionParams.modelKey;
        this.questionParams.deep_seek = modelConfig.enableThinking || this.questionParams.deep_seek;
        this.questionParams.enable_search = modelConfig.enableSearch || this.questionParams.enable_search;
        this.questionParams.max_token = modelConfig.maxTokens || this.questionParams.max_token;
        this.questionParams.temperature = modelConfig.temperature || this.questionParams.temperature;
        this.selectedTags = modelConfig.knowledgeIds || this.questionParams.topic_ids[0];
      });
    },

    getLibrary() {
      knowledgeLibrary()
        .then(({ rows }) => {
          rows = rows.map((item) => {
            item.knowledgeName = item.knowledgeName.replace("洞界", "热点").replace("热点风向标", "摩投投资库");
            if (["eYxPPqLY"].includes(item.knowledgeCode)) return null;
            return item;
          }).filter((item) => item != null);
          this.tagList = rows;
          this.selectedTags = rows[0]?.knowledgeCode;
          this.getDefaultModelConfig();
        })
        .catch(() => {});
    },

    sendUserMessage() {
      if (!this.isLogin) {
        this.$emit("openLogin");
        return;
      }
      if (this.loading) return;
      if (!this.selectedTags) {
        this.$message.warning('请选择类型');
        return;
      }
      if (this.inputMessage.trim()) {
        this.$emit("send", {
          message: this.inputMessage,
          tags: this.selectedTags,
          params: { ...this.questionParams },
        });
        this.inputMessage = "";
      }
    },

    getSelectedTags() {
      return this.selectedTags;
    },

    setInputMessage(message) {
      this.inputMessage = message;
    },
  },
};
</script>

<style scoped lang="scss">
.send {
  width: 80%;
  margin: 0 auto;
  position: absolute;
  bottom: 60px;
  left: 10%;
  border-radius: 20px;
  border: 1px solid #ffb061;
  overflow: hidden;
  padding-top: 10px;
  padding-bottom: 17px;
  background: #fff;

  .tags-list {
    display: flex;
    padding-right: 40px;
    margin-left: 20px;

    .tags {
      margin: 0 10px;
    }

    .radio {
      margin-right: 0;
    }
  }

  &-btn {
    width: 39px;
    height: 39px;
    position: absolute;
    right: 18px;
    bottom: 17px;
    cursor: pointer;

    &.disabled {
      filter: grayscale(100%);
      -webkit-filter: grayscale(100%);
    }
  }
}

.switch {
  display: flex;
  align-items: center;
}
</style>